import _post from "./NoBodyPost";
import ProgressBar from "react-bootstrap/ProgressBar";
import stylesCommon from "../stylesCommon";
import React from "react";
import _postBody from "./Post";
import CollectingASAP from "../Functions/CollectingDataASAP";
import constantURI from "../URI";
import { ASAPDB } from "../ConstantURI";
import { v4 as uuidv4 } from "uuid";

export default class SendingData extends React.Component {
  constructor() {
    super();
    this.state = {
      percentage: 0,
      user: [],
      userId: -1,
      items: [],
      products: [],
      pricelist: [],
      pricelistitems: [],
      stock: [],
      result: [],
      ids: [],
      order: [],
      signature: "",
      token: "",
      delivery: [],
      alertUndefined: false,
      username: "",
    };
  }

  async componentDidMount() {
    this.setState({
      token: JSON.parse(localStorage.getItem("Token")),
      username: JSON.parse(localStorage.getItem("Username")),
    });
    await this.sendData();
  }

  confirm = async (SO) => {
    var confirmDelivery =
      constantURI() +
      "Action?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&id=" +
      SO.order.id +
      "&action=";
    if (SO.isVendor) {
      confirmDelivery =
        confirmDelivery + "button_confirm" + "&table=" + "purchase.order";
    } else {
      confirmDelivery =
        confirmDelivery + "action_confirm" + "&table=" + "sale.order";
    }
    await _post(confirmDelivery).then((response) => {
      return response.json().then(async (data) => {
        if (data.result !== undefined) {
          await this.getDelivery(SO.order);
        } else {
          this.setState({ alertUndefined: true });
        }
      });
    });
  };

  getDelivery = async (order) => {
    const getDelivery =
      constantURI() +
      "GetDelivery?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&source=" +
      order.name;
    await _post(getDelivery).then((response) => {
      return response.json().then(async (data) => {
        if (data.result !== undefined && data.result.length !== 0) {
          await this.setState({ delivery: data.result, alertUndefined: false });
          await this.checkAvailability();
        } else {
          this.setState({ alertUndefined: true });
        }
      });
    });
  };

  checkAvailability = async () => {
    const checkAvailability =
      constantURI() +
      "Action?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&action=" +
      "action_assign" +
      "&table=" +
      "stock.picking" +
      "&id=" +
      this.state.delivery[0].id;
    await _post(checkAvailability).then((response) => {
      return response.json().then(async (data) => {
        if (data.result !== undefined) {
          await this.setQuantities();
        } else {
          this.setState({ alertUndefined: true });
        }
      });
    });
  };

  setQuantities = async () => {
    const transfer =
      constantURI() +
      "Action?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&action=" +
      "action_set_quantities_to_reservation" +
      "&table=" +
      "stock.picking" +
      "&id=" +
      this.state.delivery[0].id;
    await _post(transfer).then((response) => {
      return response.json().then(async (data) => {
        if (data.result !== undefined) {
          await this.validate();
        } else {
          this.setState({ alertUndefined: true });
        }
      });
    });
  };

  validate = async () => {
    const validate =
      constantURI() +
      "Action?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&action=" +
      "button_validate" +
      "&table=" +
      "stock.picking" +
      "&id=" +
      this.state.delivery[0].id;
    await _post(validate).then((response) => {
      return response.json().then(async (data) => {
        if (data.result !== undefined) {
          const updateSignature =
            constantURI() +
            "updateDelivery?token=" +
            this.state.token +
            "&user=" +
            this.state.username +
            "&id=" +
            this.state.delivery[0].id;
          var body = {};
          body.signature = this.state.signature;
          await _postBody(updateSignature, body).then((response) => {
            return response.json().then(async (data) => {
              if (data.result === undefined) {
                this.setState({ alertUndefined: true });
              }
            });
          });
        } else {
          this.setState({ alertUndefined: true });
        }
      });
    });
  };
  sendPunches = async () => {
    const punchday = JSON.parse(localStorage.getItem("UnsyncedPunchDay"));
    if (punchday.length !== 0) {
      punchday.map(async (day, index, arr) => {
        if (day.Url !== undefined && day.updateUrl !== undefined) {
          await _post(day.Url).then(async (response) => {
            return response.json().then(async (data) => {
              if (data.result !== undefined) {
                this.setState({ ids: data.result });
                localStorage.setItem("ids", JSON.stringify(this.state.ids));
                if (day.updateUrl !== undefined) {
                  const newURL =
                    day.updateUrl.substring(
                      0,
                      day.updateUrl.indexOf("&lineid=") + 8
                    ) + data.result;
                  day.updateUrl = newURL;
                }
              } else {
                this.setState({ alertUndefined: true });
              }
            });
          });
        }
        
        if (day.updateUrl !== undefined) {
          await _post(day.updateUrl).then((response) => {
            return response.json().then(async (data) => {
              if (data.result === undefined) {
                this.setState({ alertUndefined: true });
              }
            });
          });
        }
        if (index === arr.length - 1 && !this.state.alertUndefined) {
          await localStorage.setItem("UnsyncedPunchCount", JSON.stringify(0));
          await localStorage.setItem("UnsyncedPunchDay", JSON.stringify([]));
          this.setState({ percentage: this.state.percentage + 20 });
        }
      });
    } else {
      this.setState({ percentage: this.state.percentage + 20 });
    }
  };

  sendVisits = async () => {
    this.setState({ alertUndefined: false });
    const visitDay = JSON.parse(localStorage.getItem("UnsyncedVisitDay"));
    if (visitDay.length !== 0) {
      visitDay.map(async (day, index, arr) => {
        if (day.cancelUrl === undefined) {
          await _post(day.UrlIn).then((response) => {
            return response.json().then(async (data) => {
              if (data.result !== undefined) {
                await _post(day.UrlOut).then((response) => {
                  return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                    } else {
                      this.setState({ alertUndefined: true });
                    }
                  });
                });
              } else {
                this.setState({ alertUndefined: true });
              }
            });
          });
        } else {
          await _post(day.cancelUrl).then((response) => {
            return response.json().then(async (data) => {
              if (data.result === undefined) {
                this.setState({ alertUndefined: true });
              }
            });
          });
        }

        if (index === arr.length - 1 && !this.state.alertUndefined) {
          await localStorage.setItem("UnsyncedVisitCount", JSON.stringify(0));
          await localStorage.setItem("UnsyncedVisitDay", JSON.stringify([]));
          this.setState({ percentage: this.state.percentage + 20 });
        }
      });
    } else {
      this.setState({ percentage: this.state.percentage + 20 });
    }
  };

  sendClientLocation = async () => {
    this.setState({ alertUndefined: false });
    const clientLocation = JSON.parse(localStorage.getItem("clientLocation"));
    if (clientLocation !== null && clientLocation !== undefined) {
      clientLocation.map(async (client, index, arr) => {
        await _post(client.Url).then((response) => {
          return response.json().then(async (data) => {
            if (data.result !== undefined) {
            } else {
              this.setState({ alertUndefined: true });
            }
          });
        });

        if (index === arr.length - 1 && !this.state.alertUndefined) {
          await localStorage.setItem("clientLocation", JSON.stringify([]));

          this.setState({ percentage: this.state.percentage + 20 });
        }
      });
    } else {
      this.setState({ percentage: this.state.percentage + 20 });
    }
  };

  sendVisitsOutRoute = async () => {
    this.setState({ alertUndefined: false });
    const visitDay = JSON.parse(localStorage.getItem("UnsyncedVisitDayRoute"));
    if (visitDay !== null) {
      visitDay.map(async (day, index, arr) => {
        if(day.Url !== undefined ){
          await _post(day.Url).then((response) => {
            return response.json().then(async (data) => {
              if (data.result !== undefined) {
              } else {
                this.setState({ alertUndefined: true });
              }
            });
          });
        }

        if (index === arr.length - 1 && !this.state.alertUndefined) {
          await localStorage.setItem(
            "UnsyncedVisitDayRoute",
            JSON.stringify([])
          );
          await localStorage.setItem("visits", JSON.stringify([]));
          this.setState({ percentage: this.state.percentage + 20 });
        }
      });
    } else {
      this.setState({ percentage: this.state.percentage + 20 });
    }
  };
    // Sync locally logged competitor data to the backend, like SaleOrder sync.
  syncCompetitorLogs = async () => {
    try {
      const raw = localStorage.getItem("competitorLogs");
      if (!raw) return;
      const logs = JSON.parse(raw);
      if (!Array.isArray(logs) || logs.length === 0) return;

      const token = JSON.parse(localStorage.getItem("Token"));
      const username = JSON.parse(localStorage.getItem("Username"));
      const SelectedClientName = JSON.parse(
        localStorage.getItem("SelectedClientName"),
      );
      const SelectedClient = JSON.parse(localStorage.getItem("SelectedClient"));
      const UserId = JSON.parse(localStorage.getItem("UserId"));

      const createCompetitorURL =
        constantURI() +
        "CreateSO?token=" +token +
        "&user=" + username +
        "&type=CmpLog" +
        "&partnerId=" + SelectedClient +
        "&selectedClientName=" + SelectedClientName +
        "&discount=0" +
        "&date=" +
        "&userId=" + UserId;


      let remaining = [];
      var tempBody = {
        lines: [],
      };
      for (const log of logs) {
        try {
          if(log.isSynced) continue;
          var uuid = uuidv4();
          var tempItem = {};
          tempItem.productId = log.shopItem;
          tempItem.qty = 0;
          tempBody.lines.push(tempItem);
          var remark = "Competitor Name: " + log.competitorName
            + "; Product Name: " + log.productName
            + "; Shelf Share: " + log.shelfShare
            + "; Price: " + log.price
            + "; Promotion: " + log.promotions.join(", ")
            + "; Notes: " + log.notes;
          //"Competitor A","notes":"ABCD","shelfShare":0,"price":12,"promotions":[],"notes":"123456 7890"""
          var tUrl = createCompetitorURL + "&name=CmpLog" + "-" + uuid + "&remark=" + remark ;
          const response = await _postBody(tUrl, tempBody);
          const data = response ? await response.json() : null;
          if (data && data.result !== undefined && data.result !== null) {
            log.isSynced = true;
            // Synced successfully; drop from local store.
          } else {
            remaining.push(log);
          }
        } catch (e) {
          console.warn("Failed to sync competitor log", e);
          remaining.push(log);
        }
      }

      if (remaining.length > 0) {
        await localStorage.setItem("competitorLogs", JSON.stringify(remaining));
      } else {
        await localStorage.setItem("competitorLogs", JSON.stringify([]));
      }
    } catch (e) {
      console.warn("Failed to load/sync competitor logs", e);
    }
  };

  sendTransactions = async () => {
    this.setState({ alertUndefined: false });
    // Sync competitor logs to the backend, mirroring the SaleOrder sync flow.
    await this.syncCompetitorLogs();
    const UST = JSON.parse(localStorage.getItem("UnsyncedTransactions"));
    if (UST.length !== 0) {
      await UST.map(async (type, typeIndex, typeArr) => {
        if (type !== null && type.length !== 0) {
          await type.map(async (SO, SOIndex, SOArr) => {
            if (typeIndex === 4 && SO.basedSO) {
              this.setState({ order: SO.order, signature: SO.signature });
              await this.confirm(SO).then(async () => {
                //Empty local storage
                if (
                  typeIndex === typeArr.length - 1 &&
                  !this.state.alertUndefined
                ) {
                  await localStorage.setItem(
                    "UnsyncedTransactionsCount",
                    JSON.stringify([])
                  );
                  await localStorage.setItem(
                    "UnsyncedTransactions",
                    JSON.stringify([])
                  );
                  await localStorage.setItem(
                    "PendingInvoices",
                    JSON.stringify([])
                  );
                  this.setState({ percentage: 100 });
                }
              });
            } else {
              if (SO.state === "Unsynced") {
                //Create transaction
                await _postBody(SO.createURL, SO.Body).then((response) => {
                  if (response.status === 200) {
                    console.log(SO.createURL);
                    console.log(JSON.stringify(SO.Body));
                    return response.json().then(async (data) => {
                      var localAlert = false;
                      console.log(data);
                      if (data.result !== undefined && data.result !== null) {
                        if (
                          (typeIndex === 3 && data.result !== undefined) ||
                          (typeIndex !== 3 &&
                            ((data.result.results !== undefined &&
                              data.result.results[0].success) ||
                              (data.result.status !== undefined &&
                                data.result.status === "success")))
                        ) {
                          //Set Signature
                          if (typeIndex === 3) {
                            SO.signatureUrl =
                              SO.signatureUrl.substring(
                                0,
                                SO.signatureUrl.indexOf("&id=") + 4
                              ) + data.result;
                          } else if (
                            data.result.results !== undefined &&
                            data.result.results[0].success
                          ) {
                            SO.signatureUrl =
                              SO.signatureUrl.substring(
                                0,
                                SO.signatureUrl.indexOf("&id=") + 4
                              ) + data.result.results[0].recordID;
                          }
                          localStorage.setItem(
                            "UnsyncedTransactions",
                            JSON.stringify(UST)
                          );
                          // If transaction is payment create trans receipts
                          if (typeIndex === 3) {
                           
                            SO.Invoices.map(async (invoice) => {
                              // const realURL =
                              //   invoice.URL.substring(
                              //     0,
                              //     invoice.URL.indexOf("&paymentId=") + 11
                              //   ) + data.result;
                              // await _post(realURL).then((response) => {
                              //   return response.json().then(async (data) => {
                              //     if (data.result === undefined) {
                              //       this.setState({ alertUndefined: true });
                              //       localAlert = true;
                              //     }
                              //   });
                              // });
                              await _post(invoice.UpdateURL).then(
                                (response) => {
                                  return response.json().then(async (data) => {
                                    if (data.result === undefined) {
                                      this.setState({ alertUndefined: true });
                                      localAlert = true;
                                    }
                                  });
                                }
                              );
                            });
                          }
                          if (
                            data.result.results !== undefined &&
                            data.result.results[0].success
                          ) {
                            var body = {};
                            body.signature = SO.signature;
                            await _postBody(SO.signatureUrl, body).then(
                              (response) => {
                                return response.json().then(async (data) => {
                                  if (data.result === undefined) {
                                    this.setState({ alertUndefined: true });
                                    SO.updateState = "Unsynced";
                                  } else {
                                    SO.updateState = "Synced";
                                  }
                                  if (!localAlert) {
                                            SO.state = "Synced";
                                            // Persist this successfully synced transaction so it can appear in Sent section
                                            try {
                                              await this.addLastSynced(typeIndex, SO);
                                            } catch (e) {
                                              console.warn('addLastSynced failed', e);
                                            }
                                  }
                                  localStorage.setItem(
                                    "UnsyncedTransactions",
                                    JSON.stringify(UST)
                                  );
                                  //Empty local storage
                                  if (
                                    typeIndex === typeArr.length - 1 &&
                                    !this.state.alertUndefined
                                  ) {
                                    await localStorage.setItem(
                                      "UnsyncedTransactionsCount",
                                      JSON.stringify([])
                                    );
                                    await localStorage.setItem(
                                      "UnsyncedTransactions",
                                      JSON.stringify([])
                                    );
                                    await localStorage.setItem(
                                      "PendingInvoices",
                                      JSON.stringify([])
                                    );
                                    this.setState({ percentage: 100 });
                                  } else if (
                                    typeIndex === typeArr.length - 1 &&
                                    this.state.alertUndefined
                                  ) {
                                    this.setState({ percentage: 100 });
                                  }
                                });
                              }
                            );
                          } else if (
                            data.result.status !== undefined &&
                            data.result.status === "success"
                          ) {
                            this.setState({ percentage: 100 });
                            if (
                              typeIndex === typeArr.length - 1 &&
                              !this.state.alertUndefined
                            ) {
                              await localStorage.setItem(
                                "UnsyncedTransactionsCount",
                                JSON.stringify([])
                              );
                              await localStorage.setItem(
                                "UnsyncedTransactions",
                                JSON.stringify([])
                              );
                              await localStorage.setItem(
                                "PendingInvoices",
                                JSON.stringify([])
                              );
                              this.setState({ percentage: 100 });
                            }
                          }else if (data.result !== undefined){
                            
                            if (
                              typeIndex === typeArr.length - 1 &&
                              !this.state.alertUndefined
                            ) {
                              await localStorage.setItem(
                                "UnsyncedTransactionsCount",
                                JSON.stringify([])
                              );
                              await localStorage.setItem(
                                "UnsyncedTransactions",
                                JSON.stringify([])
                              );
                              await localStorage.setItem(
                                "PendingInvoices",
                                JSON.stringify([])
                              );
                              this.setState({ percentage: 100 });
                            }
                          }
                        } else {
                          this.setState({ alertUndefined: true });
                          if (typeIndex === typeArr.length - 1) {
                            this.setState({ percentage: 100 });
                          }
                        }
                      } else {
                        this.setState({ alertUndefined: true });
                        this.setState({ percentage: 100 });
                      }
                    });
                  } else {
                    this.setState({ alertUndefined: true });
                    this.setState({ percentage: 100 });
                  }
                });
              } else if (SO.updateState === "Unsynced") {
                var body = {};
                body.signature = SO.signature;
                await _postBody(SO.signatureUrl, body).then((response) => {
                  return response.json().then(async (data) => {
                    if (data.result === undefined) {
                      this.setState({ alertUndefined: true });
                      SO.updateState = "Unsynced";
                    } else {
                      SO.updateState = "Synced";
                    }
                    localStorage.setItem(
                      "UnsyncedTransactions",
                      JSON.stringify(UST)
                    );
                    if (
                      typeIndex === typeArr.length - 1 &&
                      !this.state.alertUndefined
                    ) {
                      await localStorage.setItem(
                        "UnsyncedTransactionsCount",
                        JSON.stringify([])
                      );
                      await localStorage.setItem(
                        "UnsyncedTransactions",
                        JSON.stringify([])
                      );
                      await localStorage.setItem(
                        "PendingInvoices",
                        JSON.stringify([])
                      );
                      this.setState({ percentage: 100 });
                    }
                  });
                });
              } else if (
                typeIndex === typeArr.length - 1 &&
                !this.state.alertUndefined
              ) {
              
                await localStorage.setItem(
                  "UnsyncedTransactionsCount",
                  JSON.stringify([])
                );
                await localStorage.setItem(
                  "UnsyncedTransactions",
                  JSON.stringify([])
                );
                await localStorage.setItem(
                  "PendingInvoices",
                  JSON.stringify([])
                );
                this.setState({ percentage: 100 });
              }
            }
          });
        }
      });
    } else {
      this.setState({ percentage: 100 });
    }
  };

  localStorageFunction = async () => {
    const SendDataLog =
      constantURI() +
      "InsertLog?token=" +
      this.state.token +
      "&User=" +
      this.state.username;
    const data = JSON.parse(localStorage.getItem("UnsyncedTransactions"));
    var body = {};
    body.logData = data;
    console.log(body);
    await _postBody(SendDataLog, body).then((response) => {
      return response.json().then(async (data) => {
        console.log(data);
      });
    });
  };

  // Save a compact representation of the last synced transactions per typeIndex
  addLastSynced = async (typeIndex, SO) => {
    try {
      const raw = localStorage.getItem("LastSyncedTransactions");
      const store = raw ? JSON.parse(raw) : [];
      // Ensure array length
      while (store.length <= typeIndex) store.push([]);

      // Build a compact entry to avoid storing large circular structures
      const entry = {
        id: SO.order?.id ?? SO.id ?? (SO.Body && SO.Body.id) ?? null,
        name:
          SO.order?.name ?? SO.name ?? (SO.Body && SO.Body.name) ?? "",
        partner_id:
          SO.order?.partner_id ?? SO.partner_id ?? (SO.Body && SO.Body.partner_id) ?? [],
        amount_total:
          SO.order?.amount_total ?? SO.amount_total ?? (SO.Body && SO.Body.amount_total) ?? null,
        date:
          SO.order?.date_order ?? SO.order?.invoice_date ?? SO.date ?? new Date().toISOString(),
        state: "sent",
        timestamp: new Date().toISOString(),
      };

      // Prepend and keep recent 50
      store[typeIndex] = [entry, ...(store[typeIndex] || [])].slice(0, 50);
      localStorage.setItem("LastSyncedTransactions", JSON.stringify(store));
    } catch (e) {
      console.warn("Failed to save LastSyncedTransactions", e);
    }
  };

  sendData = async () => {
    //Send Puch In and Punch Out
    await this.sendPunches();

    //Send Visit In and Visit Out
    await this.sendVisits();

    //Send Transactions
    await this.sendTransactions();

    await this.sendVisitsOutRoute();

    await this.sendClientLocation();

    await this.localStorageFunction();
  };

  render() {
    return (
      <div
        className="container-fluid vh-100 text-center"
        style={stylesCommon.mainContainer}
      >
        {this.state.percentage >= 100 ? (
          this.state.alertUndefined ? (
            <div>
              <h3 className="pt-5">Something went wrong. Please try again.</h3>
            </div>
          ) : (
            <CollectingASAP
              history={this.props.history}
              isDone={this.props.isDone}
            ></CollectingASAP>
          )
        ) : (
          <div>
            <h3 className="pt-5">Sending data. This may take few seconds.</h3>
            <ProgressBar animated now={this.state.percentage} />
            <h3>{this.state.percentage}</h3>
          </div>
        )}
      </div>
    );
  }
}
